import { render, staticRenderFns } from "./AddCustomerAddress.vue?vue&type=template&id=1b3adae7&scoped=true&lang=pug&"
import script from "./AddCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./AddCustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerAddress.vue?vue&type=style&index=0&id=1b3adae7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3adae7",
  null
  
)

/* custom blocks */
import block0 from "./AddCustomerAddress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider,VForm,VSpacer})
